// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1tGbp","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__qN3wB"};